export const ActionTypes = {
  Adding: 1,
  Updating: 2,
  Deleting: 3
};
